import { c as _c } from "react/compiler-runtime";
import { LoginButton } from "@/components/Login/LoginButton/LoginButton.component";
import { Translation } from "@/components/Translation/Translation.component";
export function LoginPrompt() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-4 bg-silent"><LoginButton className="mt-4 w-fit md:mt-0" variant="primary"><Translation da="Log ind for at kommentere" de="Anmelden um zu kommentieren" en="Sign in to comment" no={"Logg inn for \xE5 kommentere"} sv={"Logga in f\xF6r att kommentera"} /></LoginButton></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}